// ******************************************************
// ******************************************************
// ******************************************************
// *****    Definition of the Jsons.
// *****    This code is generated. Do not edit manaully.
// ******************************************************
// ******************************************************
// ******************************************************
export var l_level_airfield = require("../../Levels/l_level_airfield.json");
export var l_level_airfield_extra = require("../../Levels/l_level_airfield_extra.json");
export var l_level_airtemple = require("../../Levels/l_level_airtemple.json");
export var l_level_airtemple_extra = require("../../Levels/l_level_airtemple_extra.json");
export var l_level_balloonfortress = require("../../Levels/l_level_balloonfortress.json");
export var l_level_balloonfortress_extra = require("../../Levels/l_level_balloonfortress_extra.json");
export var l_level_battlefield = require("../../Levels/l_level_battlefield.json");
export var l_level_battlefield_extra = require("../../Levels/l_level_battlefield_extra.json");
export var l_level_beach = require("../../Levels/l_level_beach.json");
export var l_level_beach_extra = require("../../Levels/l_level_beach_extra.json");
export var l_level_blackbeard = require("../../Levels/l_level_blackbeard.json");
export var l_level_blackbeard_extra = require("../../Levels/l_level_blackbeard_extra.json");
export var l_level_castle = require("../../Levels/l_level_castle.json");
export var l_level_castle_extra = require("../../Levels/l_level_castle_extra.json");
export var l_level_crane = require("../../Levels/l_level_crane.json");
export var l_level_crane_extra = require("../../Levels/l_level_crane_extra.json");
export var l_level_floatingcity = require("../../Levels/l_level_floatingcity.json");
export var l_level_floatingcity_extra = require("../../Levels/l_level_floatingcity_extra.json");
export var l_level_forestpicnic = require("../../Levels/l_level_forestpicnic.json");
export var l_level_forestpicnic_extra = require("../../Levels/l_level_forestpicnic_extra.json");
export var l_level_fortress = require("../../Levels/l_level_fortress.json");
export var l_level_fortress_extra = require("../../Levels/l_level_fortress_extra.json");
export var l_level_fullhouse = require("../../Levels/l_level_fullhouse.json");
export var l_level_fullhouse_extra = require("../../Levels/l_level_fullhouse_extra.json");
export var l_level_harbour = require("../../Levels/l_level_harbour.json");
export var l_level_harbour_extra = require("../../Levels/l_level_harbour_extra.json");
export var l_level_industrial = require("../../Levels/l_level_industrial.json");
export var l_level_industrial_extra = require("../../Levels/l_level_industrial_extra.json");
export var l_level_manybuildings = require("../../Levels/l_level_manybuildings.json");
export var l_level_manybuildings_extra = require("../../Levels/l_level_manybuildings_extra.json");
export var l_level_poolparty = require("../../Levels/l_level_poolparty.json");
export var l_level_poolparty_extra = require("../../Levels/l_level_poolparty_extra.json");
export var l_level_ship = require("../../Levels/l_level_ship.json");
export var l_level_ship_extra = require("../../Levels/l_level_ship_extra.json");
export var l_level_train = require("../../Levels/l_level_train.json");
export var l_level_train_extra = require("../../Levels/l_level_train_extra.json");
export var l_level_tutorial = require("../../Levels/l_level_tutorial.json");
export var l_level_tutorial_extra = require("../../Levels/l_level_tutorial_extra.json");
export var p_cartoon_dust = require("../../particles/p_cartoon_dust.json");
export var p_confetti = require("../../particles/p_confetti.json");
export var p_dust = require("../../particles/p_dust.json");
export var p_explosion = require("../../particles/p_explosion.json");
export var p_feather_black = require("../../particles/p_feather_black.json");
export var p_feather_blue = require("../../particles/p_feather_blue.json");
export var p_feather_red = require("../../particles/p_feather_red.json");
export var p_feather_yellow = require("../../particles/p_feather_yellow.json");
export var p_ice_particle = require("../../particles/p_ice_particle.json");
export var p_pig_smoke = require("../../particles/p_pig_smoke.json");
export var p_rain = require("../../particles/p_rain.json");
export var p_stone_particle = require("../../particles/p_stone_particle.json");
export var p_wood_particle = require("../../particles/p_wood_particle.json");
export var s_sparkle_trail = require("../../particles/s_sparkle_trail.json");
